import { Link, Outlet, useLocation } from 'react-router-dom';
import AuthService from '../../../../shared/services/AuthService';
import MarketplaceLayout from './MarketplaceLayout';

const NAV = [
  { to: '/marketplace/account/saved', label: 'Saved properties' },
  { to: '/marketplace/account/enquiries', label: 'My enquiries' },
  { to: '/marketplace/account/profile', label: 'Profile' },
];

export default function BuyerAccountLayout() {
  const { pathname } = useLocation();

  const logout = async () => {
    await AuthService.performLogout(null);
    window.location.assign('/marketplace');
  };

  return (
    <MarketplaceLayout>
      <div className="marketplace-container marketplace-section">
        <div className="marketplace-results-header">
          <div>
            <h1 className="marketplace-section-title">My account</h1>
            <p className="marketplace-muted">Manage saved properties, enquiries and preferences.</p>
          </div>
          <button type="button" className="market-btn market-btn-secondary" onClick={logout}>
            Sign out
          </button>
        </div>

        <nav className="marketplace-nav" style={{ marginBottom: 24, gap: 16 }}>
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              aria-current={pathname === item.to ? 'page' : undefined}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <Outlet />
      </div>
    </MarketplaceLayout>
  );
}
